import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import '../styles/slotbooking.css';
import { useAuth } from "../context/AuthContext";
import { Api } from "../api/Api";
import { showToast } from "../helpers/UIHelper";
import useCustomParams from "../hooks/useCustomParams";
import { Button, Modal, Result, Spin } from "antd";
import useCustomNavigate from "../hooks/useCustomNavigate";
import { useLocation } from "react-router-dom";

const SlotBooking = () => {
    const state = useCustomParams();
    const [queueList, setQueueList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [saveAppointment, setSaveAppointment] = useState({});
    const [selectedSlot, setSelectedSlot] = useState({});
    const [showModal, setShowModal] = useState(false);
    const navigate = useCustomNavigate();
    const Auth = useAuth();
    const otherPatient=localStorage.getItem("life-other-patient") ? JSON.parse(localStorage.getItem("life-other-patient")) : null;
    const [successComponent, setSuccessComponent] = useState(null);
    const location = useLocation();
    useEffect(() => {
        console.log('Other',otherPatient);
        const fetchData = async () => {
          setIsLoading(true);
          try {
            if (state.doctorid && state.session && state.departmentid) {
                const siteId = '2';
                const patientId = otherPatient ? otherPatient.patientId : Auth.getUser().data.patients[0].patientId;
                const mrn = Auth.getUser().data.patients[0].mrnNo;
        
                const queueResponse = await Api.get(`/api/mobileappointmentquotainfo/?deptId=${state.departmentid}&siteId=${siteId}&consultId=${state.doctorid}&sessionId=${state.session}&unitId=${state.unitId}&date=${state.date}&patientid=${patientId ? patientId : ''}`);    
                if (queueResponse.data && queueResponse.data.Status === "The Patient is already Checked In") {
                    showToast('error', 'The patient is already checked in.');
                    setIsLoading(false);
                    return;
                }  
                if (queueResponse.data.queue) {
                    setQueueList(queueResponse.data.queue);
                    setSaveAppointment({
                        mrn: mrn,
                        dept_id: state.departmentid,
                        siteId:'2',
                        consultId: state.doctorid,
                        unitId: state.unitId,
                        sessionId:state.session,
                        appointmentDate: state.date,
                        patientId: patientId
                    });
                } else {
                    showToast('error', 'No tokens found');
                }
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          } finally {
              setIsLoading(false);
          }
        };
        if (queueList.length===0) {
            fetchData();
        }
        // eslint-disable-next-line
    }, [state.departmentid,state.doctorid]);
    const formatTime = (timeString) => {
        try {
            // eslint-disable-next-line
            const [datePart, timePart] = timeString.split(' ');
            const [hours, minutes] = timePart.split(':');
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            return date.toLocaleTimeString('en-US', { 
                hour: 'numeric', 
                minute: '2-digit', 
                hour12: true 
            });
        } catch (error) {
            return '';
        }
    };
    const handleSlotPress = async (slot) => {
        setSelectedSlot({ tokenno:slot.queueno, time:slot.slotstart });
        const updatedSaveAppointment = {
            ...saveAppointment,
            siteid: '2', 
            tokenno:slot.queueno,
            time:slot.slotstart,
            apntQueueTypeId: slot.apntQueueTypeId,
            appntTypeConfId:slot.appntTypeConfId
        };
        if (Auth.getUser().data.patients[0].patientId) {
            setSaveAppointment(updatedSaveAppointment);
            try {
                setIsLoading(true);
                const response = await Api.post(`/api/MobileSaveAppointmentApi/?mrno=${otherPatient ? otherPatient.mrnNo : Auth.getUser().data.patients[0].mrnNo}`,
                    { save_appointment: [updatedSaveAppointment] }
                );
                if (response.data) {
                    if (response.data.Appointment === "Saved") {
                        showToast('success', 'Appointment Booked')
                        setSuccessComponent(<div key="appointment-details" style={{ marginBottom: '20px', textAlign: 'center' }}>
                                <p><strong>UHID :</strong> {otherPatient ? otherPatient.mrnNo : Auth.getUser().data.patients[0].mrnNo}</p>
                                <p><strong>Token Number:</strong> {slot.queueno}</p>
                                <p><strong>Date:</strong> {state.date}</p>
                                <p><strong>Session:</strong> {state.sessionName}</p>
                                <p><strong>Selected Doctor:</strong> {state.doctorName}</p>
                                <p><strong>Department:</strong> {state.deptName}</p>
                            </div>)
                        setShowModal(true);
                        // if (typeof appointmentData === 'string') {
                        //     setShowModal(true);
                        //     try {
                        //         const encounterResponse = await Api.post(
                        //             '/api/mobilesaveEncounterinfo/',
                        //             updatedSaveAppointment
                        //         );
                        //         if (encounterResponse.data && encounterResponse.data.response === 'Saved') {
                        //             showToast('success', 'Appointment Booking Saved.');
                        //         } else {
                        //             showToast('error', 'Encounter info not saved. Please try again.');
                        //         }
                        //     } catch (error) {
                        //         showToast('error', 'Error saving encounter info');
                        //         console.error('Error saving encounter info:', error);
                        //     }
                        // } else {
                        //     showToast('error', 'Invalid appointment data. Please try again.');
                        //     console.warn('Appointment data is not a string:', appointmentData);
                        // }
                    } else {
                        showToast('error', 'This slot is already booked. Please select another one.');
                    }
                } else {
                    showToast('error', 'Failed to save appointment,Please try again');
                }
            } catch (error) {
                showToast('error', 'Failed to save appointment,Please try again');
            } finally {
                setIsLoading(false);
            }
        } else {
            setIsLoading(true);
            const patient = Auth.getUser().data.patients[0];
            const appointmentDetail = {
                departmentid:state.departmentid,
                doctorid: state.doctorid,
                appointmentdate: state.date,
                sessionid: state.session,
                unitid: state.unitId,
                patietfirstname: otherPatient ? otherPatient.firstName : patient.firstName,
                patientlastname: otherPatient ? otherPatient.lastName : patient.lastName,
                contactno: patient.mobileNumber,
                siteid: '2',
                queno:slot.queueno,
            };
            Api.post(`/df/appointment/saveappointment`, appointmentDetail).then((resp) => {
                if (resp.status === 200) {
                    setSuccessComponent(<div key="appointment-details" style={{ marginBottom: '20px', textAlign: 'center' }}>
                        <p><strong>Temporary UHID:</strong> {resp.data.mrno}</p>
                        <p><strong>Token Number:</strong> {resp.data.tokenno}</p>
                        <p><strong>Date:</strong> {state.date}</p>
                        <p><strong>Session:</strong> {state.sessionName}</p>
                        <p><strong>Selected Doctor:</strong> {state.doctorName}</p>
                        <p><strong>Department:</strong> {state.deptName}</p>
                    </div>)
                    setShowModal(true);
                } else {
                    showToast('error',resp.data.status);
                    console.log('error occured');
                }
                setIsLoading(false);
            }).catch((e) => {
                console.log(e);
                setIsLoading(false);
            });
        }
    };
    
    return (
        <div className="slot-booking-page">
            <PageHeader title="Slot Booking" />
            <div className="page-sub-title">
                Select Slot
            </div>
            <div className="selected-doctor-container">
                <div className="selected-doctor">
                    <div className="doctor-name">
                        {state.drdesignation+" "+state.doctorName}
                    </div>
                    <div className="sub-text">
                        {state.deptName} - {state.date} - {state.sessionName}
                    </div>
                    <div className="booked-for">
                        Booking For { otherPatient ? otherPatient.patientName : Auth.getUser().data.patients[0].patientName }
                    </div>
                </div>
            </div>
            <div className="queue-list">
                {!isLoading ? 
                    <>
                    {
                        queueList.map((slot, index) =>
                            <div className="queue-item" key={index} onClick={() => { handleSlotPress(slot); }}>
                                <div className="slot-no">
                                    {slot.queueno}
                                </div>
                                {slot.slotstart !==0 ? <div className="slot-time">
                                    {formatTime(slot.slotstart)}
                                </div>:<></>}
                            </div>
                        )
                    }
                    </> :
                    <div className="loading">
                        <Spin/>
                    </div>
                }
            </div>
            <Modal open={showModal} footer={null} closable={false} maskClosable={false}>
                <Result
                    status="success"
                    title="Booking Successfull"
                    subTitle="Your appointment booking is confirmed"

                    extra={[successComponent,
                        <Button type="primary" key="console" onClick={() => { navigate('/', { state: { previousPath: location.pathname } }) }}>Home</Button>,
                        <Button key="buy" onClick={() => { navigate('/departments',{state: { previousPath: location.pathname },forOtherPatient:otherPatient ? true : false}) }}>Book Another</Button>,
                    ]}
                />
            </Modal>
        </div>
    )    
}
export default SlotBooking;